<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"></loading>
    <b-form @submit.stop.prevent="guardar">
      <div >
        <b-tabs class="mr-3 ml-3">
          <b-tab class="p-0">
            <template #title>
              Datos del estado de la Promoción
            </template>

            <div class="scrollPorTabs mt-1">
              <b-row class="mb-2">
                <b-col>
                  <p style="color: var(--color-dentalia); font-weight: 600" class="mt-2">Datos generales</p>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12" md="5" lg="5">
                  <b-col>
                    <b-form-group align="left">
                      <label class="letter">Nombre del estado de la promoción <validacion/> </label>
                      <b-input-group size="sm">
                        <b-form-input
                            class="redondeo"
                            id="nombreEstadoPromocion"
                            name="nombreEstadoPromocion"
                            placeholder="Ingresa el nombre del estado de la promoción"
                            v-model="$v.objGuardar.nombreEstadoPromocion.$model"
                            :state="validateState('nombreEstadoPromocion')"
                            required
                        ></b-form-input>
                      </b-input-group>
                    </b-form-group>
                    <b-form-invalid-feedback :state="objGuardar.nombreEstadoPromocion != '' && objGuardar.nombreEstadoPromocion != null">
                      Se debe colocar nombre al estado de la promoción
                    </b-form-invalid-feedback>
                    <b-form-invalid-feedback :state="$v.objGuardar.nombreEstadoPromocion.maxLength">
                      El nombre a ingresar no debe exceder los 30 caracteres.
                    </b-form-invalid-feedback>
                  </b-col>
                </b-col>
                <b-col cols="12" md="5" lg="5">
                  <b-col>
                    <b-form-group align="left">
                      <label class="letter">Descripción del estado de la promoción <validacion/> </label>
                      <b-input-group size="sm">
                        <b-form-textarea
                            class="redondeo"
                            id="descripcionCategoriaPromocion"
                            placeholder="Ingresa la descripción del estado de la promoción"
                            v-model="$v.objGuardar.descripcionEstadoPromocion.$model"
                            :state="validateState('descripcionEstadoPromocion')"
                            required
                            rows="3"
                            max-rows="4"
                        ></b-form-textarea>
                      </b-input-group>
                    </b-form-group>
                    <b-form-invalid-feedback :state="objGuardar.descripcionEstadoPromocion != '' &&  objGuardar.descripcionEstadoPromocion != null">
                      Se debe colocar descripción al estado de la promoción
                    </b-form-invalid-feedback>
                    <b-form-invalid-feedback :state="$v.objGuardar.descripcionEstadoPromocion.maxLength">
                      La descripcion a ingresar no debe exceder los 100 caracteres.
                    </b-form-invalid-feedback>
                  </b-col>
                </b-col>
              </b-row>

              <div class="mt-2 col-md-12"></div>

            </div>
          </b-tab>
          <div class="text-center">
            <b-button
                class="mt-3 mr-4 botonesAzulFuerte"
                variant="primary"
                style="margin:10px"
                @click="$refs.submitGuardar.click()">Guardar
            </b-button>

            <b-button
                class="mt-3 ml-4 botonesGrisFuerte"
                style="margin:10px"
                @click="() => {$emit('cancelar')}">Cancelar
            </b-button>
          </div>
        </b-tabs>
      </div>
      <b-button v-show="false" id="submitGuardar" ref="submitGuardar" type="submit" style="visibility: hidden"></b-button>
    </b-form>
  </div>
</template>

<script>
import {validationMixin} from "vuelidate";
import {maxLength, required} from "vuelidate/lib/validators";

export default {
  name: "altaEstadoPromocion",
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      loading: false,
      objGuardar: {
        nombreEstadoPromocion:null,
        descripcionEstadoPromocion: null
      }
    }
  },
  props:{
    estadoOriginal: Object,
  },
  mixins: [validationMixin],
  validations() {
    return {
      objGuardar: {
        nombreEstadoPromocion: {required, maxLength: maxLength(30)},
        descripcionEstadoPromocion:{required, maxLength: maxLength(100)}
      }
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.$nextTick(() => {
      this.$v.$reset()
    });
    if (this.estadoOriginal != null && this.estadoOriginal != undefined) {
      this.objGuardar = JSON.parse(JSON.stringify(this.estadoOriginal));
    }
  },
  methods: {
    validateState(name) {
      const {$dirty, $error} = this.$v.objGuardar[name];
      return $dirty ? !$error : null;
    },
    guardar() {
      this.$v.objGuardar.$touch();
      if (this.$v.objGuardar.$anyError) {
        return;
      }
      this.loading = true;

      this.$http
          .post(this.$api + "estadoPromocion/guardarActualizarEstadosPromocion", this.objGuardar)
          .then((response) => {
            if (response.status === 200) {
              this.$swal.fire({
                position: "center",
                icon: response.data.data != null ? "success" : "info",
                title: "Aviso",
                text: response.data.data != null ? "Estado registrado correctamente" : response.data.message,
                showConfirmButton: false,
                timer: 3500,
              });
              if (response.data.data != null){
                this.$emit("actualizar", this.objGuardar);
              }

              this.$nextTick(() => {
                this.$v.$reset()
              });
            }
          }).catch((error)=>{
        console.error(error);
        this.$swal.fire({
          position: "center",
          icon: "error",
          title: "Ocurrio un error al registrar el estado",
          showConfirmButton: false,
          timer: 3500,
        });
      }).finally(() => {
        this.loading = false;
        this.$emit('cancelar')
      });
    },
  }
}
</script>

<style scoped>

</style>
